
define('eteration/eteration-base',[ 'jquery', 'knockout', 'eteration/eteration-ajax',
		'eteration/eteration-urlparser' ], function($, ko, etrAjax, urlParser) {

	var modulePath = function(module) {
		var curEl = $("#" + module);
		var path = curEl.attr('aref') + '/module/' + module + '/';
		return path;
	};

	var modelViewPath = function(module, view) {
		var curEl = $("#" + module);
		var path = curEl.attr('aref') + '/' + view;
		return path;
	};

	var loadStaticFragment = function(settings) {
		var module = settings.module;
		var template = settings.tmpl;
		var success = settings.success;
		var el = settings.el;
		var app = settings.app;
		var cache = settings.cache || false;

		var async = settings.async;

		if (async == undefined) {
			async = true;
		}

		if (!el)
			el = $("#" + module);

		if (!template)
			template = module;

		var url;
		if (!app)
			url = modulePath(module);
		else
			url = etrAjax.getAppURL(app) + '/module/' + module + '/';

		var onSuccess = function(response, status, xhr) {

			el.html(response);
			ko.cleanNode(el[0]);
			success(response, status, xhr);
		};

		var toCDNPATH = function(url) {
			if (window.cdnDomain) {
				url = window.cdnDomain + url;
			}
			return url;
		};

		var allPath = toCDNPATH(url + "views/" + template + ".html?"
				+ requireConfig.urlArgs);

		var requestFragment = function() {
			$.ajax({
				url : allPath,
				type : "GET",
				contentType : "text/plain",
				async : async,
				cache : true,
				processData : false,
				beforeSend : function(xhr) {
				},
				success : function(response, status, xhr) {
					onSuccess(response, status, xhr);
					$(document).trigger('contentReady');
				}
			});
		}

		requestFragment();
	};

	return {
		loadStaticFragment : loadStaticFragment
	};

});
